/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data IDs used in the Segment Insights screen.
 * @export
 */
export const CUSTOMERS_DATA_IDS = {
  customerListEmptyState: `Customers: No customers matching segment`,
  customerListLink: `Button: Navigate to customer profile`,
  customersEmptyState: `Customers: No segments`,
  customersEmptyStateButton: `Button: Go to segmentation`,
  exportButton: `Button: Export as CSV`,
  exportToastFailure: `Toast: Export error`,
  exportToastSuccess: `Toast: Export in progress`,
  segmentPickerApply: `Button: Apply segment`,
  segmentPickerSelect: `Form field: Select segment`,
};

/**
 * The form field ids used in the Customers screen.
 * @export
 */
export const CUSTOMERS_FORM_IDS = {
  segment: `segment`,
};
